import './style.css';
import { AxiosError } from 'axios';
import api from '../../services/api';
import Grid from '../../components/grid';
import { useState, useEffect } from 'react';
import { useAppSelector } from '../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import Button from '../../rxlib/components/buttons/button';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import InputLabel from '../../rxlib/components/input-label';
import { ApiError, ListagemProps } from '../../services/tipos';
import { formatarTamanhoDoBanco } from '../../services/utilitarios';
import { usuarioTemPermissao } from '../../rxlib/services/seguranca';
import AcessoBloqueado from '../../rxlib/components/acesso-bloqueado';
import { RxlibLayout } from '../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../rxlib/components/select/select-label';
import { ModalWarning } from '../../rxlib/components/modal/modal-warning';
import Breadcrumb, { BreadcrumbItem } from '../../rxlib/components/breadcrumb';
import { formatarDataHora, tratarErroApi } from '../../rxlib/services/utilitarios';

interface Filtros {
    campo: string;
    valor: string;
}

interface DadosLicencaDesktop {
    id: string;
    nome: string;
    cnpjBase: string;
    ultimoAcesso: Date;
    sistemaOperacional: string;
    tamanhoBanco: string;
    dados: string;
    versao: string;
    licenciada: string;
    produto: string;
    quantidade: number;
}

interface HistoricoAcessoLicenca {
    Versao?: string;
    LicencaDesktop?: {
        Nome?: string;
        CnpjBase?: string;
        Produto?: {
            Nome?: string;
        };
    };
}

interface ApiItem {
    IdHistoricoAcessoLicenca: string;
    Nome: string;
    UltimoAcesso: string;
    SistemaOperacional: string;
    TamanhoBanco: number;
    Dados: string;
    HistoricoAcessoLicenca?: HistoricoAcessoLicenca;
}

type DadosLicencaDesktopInterno = DadosLicencaDesktop & {
    nomesUnicos: Set<string>;
};

type DadosExtra = {
    campo: string;
    valor: any;
};

const campos: any = [
    { Valor: '', Campo: 'Selecione o campo para filtrar' },
    { Valor: 'Nome', Campo: 'Nome' },
    { Valor: 'CnpjBase', Campo: 'CNPJ Base' }
];

const colunasDefault: GridColDef[] = [
    { field: "licenciada", headerName: "Nome", width: 500, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "cnpjBase", headerName: "CNPJ Base", width: 100, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "produto", headerName: "Produto", width: 90, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "versao", headerName: "Versão", width: 100, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "sistemaOperacional", headerName: "Sistema Operacional", width: 360, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "tamanhoBanco", headerName: "Tamanho Banco", width: 160, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "ultimoAcesso", headerName: "Ultimo Acesso", width: 170, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
    { field: "quantidade", headerName: "Quantidade Usuários", width: 170, headerClassName: "caronte-grid-header", cellClassName: "caronte-grid-cell" },
];

function obterLicenciada(item: ApiItem): string {
    return item.HistoricoAcessoLicenca?.LicencaDesktop?.Nome ?? 'Não identificado';
}

function obterCnpjBaseLicenciada(item: ApiItem): string {
    return item.HistoricoAcessoLicenca?.LicencaDesktop?.CnpjBase ?? 'Não identificado';
}

function obterProduto(item: ApiItem): string {
    return item.HistoricoAcessoLicenca?.LicencaDesktop?.Produto?.Nome ?? 'Não identificado';
}

function parseDadosExtras(dados?: string): DadosExtra[] {
    if (!dados) return [];

    try {
        return JSON.parse(dados) as DadosExtra[];
    } catch {
        console.warn('Não foi possível parsear os dados extras da licença desktop.');
        return [];
    }
}

function ConsultaDados(props: ListagemProps) {
    const [dados, setDados] = useState<GridRowsProp>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [colunas, setColunas] = useState<GridColDef[]>(colunasDefault);
    const [campoSelecionado, setCampoSelecionado] = useState<string>('');
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(false);

    const [filtros, setFiltros] = useState<Filtros>({
        campo: '',
        valor: '',
    });

    const { register, handleSubmit } = useForm<Filtros>();

    const handleHide = () => setShowWarning(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Consulta dados licenças desktop', link: '' },
    ];

    let temPermissao = usuarioTemPermissao(token, 'consulta_dados_licenca_desktop_visualizar');

    useEffect(() => {
        if ((temPermissao) && (realizarConsulta)) {
            setCarregando(true);

            let request = '/OData/HistoricoAcesssoUsuario?$select=idHistoricoAcessoLicenca,nome,ultimoAcesso,sistemaOperacional,tamanhoBanco,dados&';

            if ((filtros.campo !== '') && (filtros.valor !== ''))
                request += `$filter=contains(toupper(historicoAcessoLicenca/licencaDesktop/${filtros.campo}),toupper('${filtros.valor}'))&`;

            request += `$expand=historicoAcessoLicenca($select=versao;$expand=licencaDesktop($select=nome,cnpjBase;$expand=produto($select=nome)))`;

            api.get(request)
                .then(response => {
                    setTimeout(() => {
                        const mapaLicencas = new Map<string, DadosLicencaDesktopInterno>();

                        for (const item of response.data.value as ApiItem[]) {

                            const nome: string = item.Nome;
                            const licenciada: string = obterLicenciada(item);
                            const ultimoAcesso: Date = new Date(item.UltimoAcesso);

                            const existente = mapaLicencas.get(licenciada);

                            if (!existente) {
                                mapaLicencas.set(licenciada, {
                                    id: item.IdHistoricoAcessoLicenca,
                                    nome,
                                    ultimoAcesso,
                                    sistemaOperacional: item.SistemaOperacional,
                                    tamanhoBanco: formatarTamanhoDoBanco(item.TamanhoBanco),
                                    dados: item.Dados,
                                    versao: item.HistoricoAcessoLicenca?.Versao ?? 'Não identificada',
                                    licenciada,
                                    cnpjBase: obterCnpjBaseLicenciada(item),
                                    produto: obterProduto(item),
                                    nomesUnicos: new Set([nome]),
                                    quantidade: 1
                                });

                                continue;
                            }

                            existente.nomesUnicos.add(nome);
                            existente.quantidade = existente.nomesUnicos.size;

                            if (ultimoAcesso > existente.ultimoAcesso) {
                                Object.assign(existente, {
                                    id: item.IdHistoricoAcessoLicenca,
                                    nome,
                                    ultimoAcesso,
                                    sistemaOperacional: item.SistemaOperacional,
                                    tamanhoBanco: formatarTamanhoDoBanco(item.TamanhoBanco),
                                    dados: item.Dados,
                                    versao: item.HistoricoAcessoLicenca?.Versao ?? 'Não identificada',
                                    cnpjBase: obterCnpjBaseLicenciada(item),
                                    produto: obterProduto(item)
                                });
                            }
                        }

                        const camposExtras = new Set<string>();

                        const dadosLicencaDesktopData: any[] =
                            Array.from(mapaLicencas.values()).map(
                                ({ nomesUnicos, ...item }) => {
                                    const dadosExtrasArray = parseDadosExtras(item.dados);
                                    dadosExtrasArray.forEach(d => camposExtras.add(d.campo));

                                    const dadosExtras = Object.fromEntries(
                                        dadosExtrasArray.map(d => [d.campo, d.valor])
                                    );

                                    return {
                                        ...item,
                                        ...dadosExtras,
                                        ultimoAcesso: formatarDataHora(item.ultimoAcesso.toISOString())
                                    };
                                }
                            );

                        const colunasExtras: GridColDef[] =
                            Array.from(camposExtras).map(campo => ({
                                field: campo,
                                headerName: campo,
                                width: 170,
                                headerClassName: "caronte-grid-header",
                                cellClassName: "caronte-grid-cell",
                            }));

                        setColunas([...colunasDefault, ...colunasExtras]);
                        setDados(dadosLicencaDesktopData);
                        setRealizarConsulta(false);
                        setCarregando(false);
                    }, 250);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregando(false);
                    setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                    setShowWarning(true);
                });
        }
    }, [temPermissao, filtros, realizarConsulta]);

    const onSubmit: SubmitHandler<Filtros> = data => {
        setFiltros({
            campo: data.campo,
            valor: data.valor,
        });

        setRealizarConsulta(true);
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>Consulta dados licenças desktop</h6>
                            </div>
                        </div>
                        <div className='row px-1 mt-2'>
                            <div className='col-2 ml-0'>
                                <SelectLabel
                                    action=''
                                    foco='sim'
                                    name='campo'
                                    itens={campos}
                                    label='Campo:'
                                    required='nao'
                                    id='selectCampo'
                                    ariaLabel='campo'
                                    campoExibicaoRegistro='Campo'
                                    valorSelecionado={filtros.campo}
                                    campoIdentificadorRegistro='Valor'
                                    className='rxlib-select-label-coluna'
                                    referencia={register({ required: false })}
                                    onChange={(e) => setCampoSelecionado(e.currentTarget.value)} />
                            </div>
                            <div className='col-2'>
                                <InputLabel
                                    type='text'
                                    name='valor'
                                    label='Valor:'
                                    maxLength={50}
                                    id='inputValor'
                                    required={false}
                                    readOnly={false}
                                    autoFocus={false}
                                    defaultValue={filtros.valor}
                                    className='rxlib-input-label-coluna'
                                    placeholder='Valor que será filtrado'
                                    referencia={register({ required: false })}
                                    mask={campoSelecionado === 'CnpjBase' ? 'number' : undefined} />
                            </div>
                            <div className='col-1 rxlib-celula-botao' style={{ padding: '0' }}>
                                <Button
                                    type='submit'
                                    texto='Pesquisar'
                                    classStyle='btn-rxlib' />
                            </div>
                            <div className='col-7' />
                        </div>
                        <div className='row px-1 mt-2'>
                            <div className='consulta-grid-dados-licenca-desktop'>
                                <Grid
                                    linhas={dados}
                                    colunas={colunas}
                                    carregando={carregando} />
                            </div>
                        </div>
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    onHide={handleHide}
                    message={messageWarning} />
                <AcessoBloqueado
                    permissao={temPermissao} />
            </RxlibLayout>
        </>
    );
}

export default ConsultaDados;